<template>
  <div class="register-page">
    <div class="container">
      <div class="col-lg-6 offset-lg-3 col-md-12 offset-md-0 col-sm-12 offset-sm-0 container-register-page">
        <div class="text-center mt10 mb30">
          <img src="/static/ccall.png" class="logo-ccall" width="200" />
        </div>

        <form @submit.prevent="setPassword">
          <div class="form-header">{{$t('register.needSetPassword')}}</div>
          <p>{{$t('register.passwordGuide')}}</p>
          <div class="form-group">
            <input type="password" class="form-control text-center" v-model="password" :placeholder="$t('register.password')" :class="{'form-error': errorMessage['password']}" autocomplete="new-password" />
            <p v-for="msg in errorMessage['password']" class="text-error">{{msg}}</p>
          </div>
          <div class="form-group text-center btn-submit">
            <base-button type="submit" class="btn-block" :disabled="password.length == 0 || isDisabled">{{$t('register.next')}}</base-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseButton from "../components/Button.vue";

  export default {
    components: {
      BaseButton,
    },
    name: 'PasswordPage',
    props: {
      phone: String,
      token: String,
    },
    data() {
      return {
        password: '',
        errorMessage: [],
        isDisabled: false,
        event_name: ''
      };
    },
    methods: {
      setPassword() {
        this.isDisabled = true;
        this.errorMessage = [];
        const formData = new FormData();
        formData.append('phone', this.phone);
        formData.append('token', this.token);
        formData.append('password', this.password);
        this.axios.post('/password', formData).then((response) => {
          if ((response.data.status)) {
            this.$router.push({name: 'InfoPage', params: {token: response.data.data.token}});
          } else {
            this.isDisabled = false;
            this.errorMessage = response.data.data;
          }
        })
      }
    }
  };
</script>
<style scoped="">
  .btn-block {
    width: 80% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PasswordPage.vue